const reportingQueryOptions = (t) => [
  {
    name: 'report',
    displayName: t('queryBuilder.queryParam.queryOptions.reporting.report'),
    type: 'reportingDate',
    used: false,
    value: ''
  },
  // {
  //   name: 'sort',
  //   displayName: t('queryBuilder.queryParam.queryOptions.reporting.sort.title'),
  //   type: 'key-value',
  //   values: [
  //     { name: 'asc', displayName: t('queryBuilder.queryParam.queryOptions.reporting.sort.values.asc') },
  //     { name: 'desc', displayName: t('queryBuilder.queryParam.queryOptions.reporting.sort.values.desc') }
  //   ],
  //   used: false,
  //   value: ''
  // },
  {
    name: 'pagination',
    displayName: '',
    type: 'pagination',
    used: true,
    value: ''
  }
];

export default reportingQueryOptions;
